import { isNullOrUndefined } from "ceres/app/helper/utils";

const state = () => ({
    shippingCountries: []
});

const getCountryIsoCode = (state, countryId) => {
    if (countryId > 0) {
        let country = state.shippingCountries.find(country => country.id === countryId);

        if (isNullOrUndefined(country)) {
            country = state.euShippingCountries.find(country => country.id === countryId);
        }

        if (!isNullOrUndefined(country)) {
            return country.isoCode2;
        }
    }

    return "";
};

const getters =
    {
        getCountryIsoCode: state => countryId => {
            if (countryId > 0) {
                return getCountryIsoCode(state, countryId);
            }

            return "";
        },

        getCountryIconClass: state => countryId => {
            if (countryId > 0) {
                const isoCode = getCountryIsoCode(state, countryId);

                if (!isNullOrUndefined(isoCode)) {
                    return "flag-icon-" + isoCode;
                }
            }

            return "";
        }
    };

export default {
    state,
    getters
};
